export default "__VITE_PUBLIC_ASSET__300da986__"